import React from 'react';
import { StarOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import { scrollToElement } from './gsap';
import './landing.css';

const PublicFooter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const goToSection = (id: string) => {
    if (location.pathname === '/') {
      scrollToElement(id);
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="metamask-footer ts-footer">
      <div className="ts-footer-container">
        <div className="ts-footer-section">
          <div className="ts-footer-brand">
            <img
              src="/images/logo.png"
              alt="Logo"
              className="ts-footer-logo"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const fallback = e.currentTarget.nextElementSibling as HTMLElement | null;
                if (fallback) fallback.style.display = 'inline-block';
              }}
            />
            <StarOutlined style={{ display: 'none', color: '#f6851b', fontSize: 22 }} />
            <span className="ts-footer-brand-name">Telegram Stars</span>
          </div>
          <p className="ts-footer-desc">{t.footer.description}</p>
        </div>

        <div className="ts-footer-section">
          <h5 className="ts-footer-subtitle">{t.footer.product}</h5>
          <ul className="ts-footer-links">
            <li><button type="button" onClick={() => goToSection('features')}>{t.footer.features}</button></li>
            <li><button type="button" onClick={() => goToSection('pricing')}>{t.footer.pricing}</button></li>
            <li><button type="button" onClick={() => navigate('/how-it-works')}>{t.nav.howItWorks}</button></li>
            <li><button type="button" onClick={() => navigate('/why')}>{t.nav.why}</button></li>
            <li><button type="button" onClick={() => navigate('/blog')}>{t.nav.blog}</button></li>
          </ul>
        </div>

        <div className="ts-footer-section">
          <h5 className="ts-footer-subtitle">{t.footer.support}</h5>
          <ul className="ts-footer-links">
            <li><button type="button" onClick={() => navigate('/login')}>{t.footer.signIn}</button></li>
            <li><button type="button" onClick={() => goToSection('faq')}>{t.faq.title}</button></li>
            <li><button type="button">{t.footer.docs}</button></li>
          </ul>
        </div>
      </div>

      <div className="ts-footer-bottom">
        <span>{t.footer.copyright}</span>
        <span className="ts-footer-badge">
          <span className="ts-eyebrow-dot" />
          {t.stats.uptime} 99.9%
        </span>
      </div>
    </footer>
  );
};

export default PublicFooter;
